(function ($) {
    $("body[data-row-styles] input[type=checkbox]").change(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('active');
        } else {
            $(this).parent().removeClass('active');
        }
        
    });

    var row_radio_inputs = $('body[data-row-styles] .radio-buttons label input');

    row_radio_inputs.each(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('active');
        }

    });

    $('body[data-row-styles]').on("change", ".radio-buttons label input", function () {
        $(this).parents(".radio-buttons").find("label").removeClass('active');
        $(this).parent().addClass('active');
    });

}(window.jQuery));


